// #region Imports
/**
 * To use react related functionality
 */
import React from 'react';
// #endregion

const withError = WrappedComponent => props => {
    // checks if the error prop is present in the props object.
    if (!props.error) {
        //return the WrappedComponent component
        return <WrappedComponent {...props} />;
    }
    const {error, ...componentProps} = props;
    //return WrappedComponent with error
    return (
        <div className="otp-has-error">
            <WrappedComponent {...componentProps} />
            {/* display error message */}
            <div className="otp-component-error">
                {error.msg}
            </div>
        </div>
    );
};

export default withError;